<template>
  <v-layout column class="text-xs-left">
    <v-expansion-panel
      class="elevation-0 mb-3"
      v-for="(section, i) in previousUnsubmittedSections"
      :key="section.id"
    >
      <v-expansion-panel-content>
        <div
          slot="header"
          class="expansion-panel__header subheading font-weight-bold"
        >
          <v-layout row align-center>
            <div>
              {{ buildSectionName(section) }}
            </div>
            <v-spacer />
            <v-chip
              small
              class="white--text info"
              v-if="
                sectionHasAllOptionalUnansweredQuestions(
                  currentQuestionnaire,
                  section,
                )
              "
              >Optional</v-chip
            >
            <v-chip
              small
              class="white--text success"
              v-else-if="sectionCompleted(currentQuestionnaire, section)"
              >Completed</v-chip
            >
            <v-chip small class="white--text error" v-else>Incomplete</v-chip>
          </v-layout>
        </div>
        <v-divider />
        <v-card class="expansion-card__content pa-4" flat>
          <sc-flex v-if="!getEngagementLetterSigned(section)">
            <sc-p class="engagement_letter_error_message" align="center">
              {{
                projectViewEnabled
                  ? $t('questionnaire.jumpToEngagementLetterStep')
                  : $t('questionnaire.jumpToEngagementLetterSection')
              }}
            </sc-p>
          </sc-flex>
          <v-layout column>
            <v-layout
              class="mb-1"
              column
              v-for="(question, i) in itemsToReviewAndSubmit(section)"
              :key="i"
            >
              <v-layout align-start>
                <div v-if="question.questionNumber" class="question-number">
                  {{ question.questionNumber }}.
                </div>
                <div
                  v-else
                  class="question-number question-number--empty"
                ></div>
                <sx-html :text="question.text"></sx-html>
              </v-layout>
              <div class="darkgrey--text ml-3" v-if="isEmpty(question.answer)">
                Unanswered
                <span v-if="question.answer_by">
                  (answer by
                  {{ moment(question.answer_by).format('ll') }})</span
                >
              </div>
              <div v-else class="ml-3 primary--text">
                {{ formattedAnswer(question) }}
              </div>
            </v-layout>
          </v-layout>
          <v-layout column align-center>
            <v-btn
              class="text-none primary mb-0 mt-3"
              @click="$emit('go-to-section', section)"
            >
              {{ $t('questionnaire.jumpTo') }}
              {{
                projectViewEnabled
                  ? $t('questionnaire.jumpToStep')
                  : $t('questionnaire.jumpToSection')
              }}
            </v-btn>
          </v-layout>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-layout>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import { mapGetters } from 'vuex';
import moment from 'moment';
import QuestionnaireMixin from '@/mixins/QuestionnaireMixin';
import FirmPreferenceMixins from '@/mixins/FirmPreferenceMixins';
import SxHtml from '../sx/SxHtml';

export default {
  props: {
    currentQuestionnaire: {
      type: Object,
      default: () => {},
    },
    currentSection: {
      type: Object,
      default: () => {},
    },
    buildSectionName: {
      type: Function,
      default: () => null,
    },
    sectionHasAllOptionalUnansweredQuestions: {
      type: Function,
      default: () => null,
    },
  },
  components: { SxHtml },

  data() {
    return {};
  },
  mixins: [QuestionnaireMixin, FirmPreferenceMixins],
  computed: {
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),
    previousUnsubmittedSections() {
      return this.shownSections
        .filter(
          s =>
            s.order < this.currentSection.order &&
            s.section_key !== 'document_checklist',
        )
        .filter(s => {
          const isEngagementLetterSigned =
            s.section_type === 2 && s.marked_completed;
          const allQuestionsSubmitted =
            s.section_type === 3 &&
            s.questionnaire_questions.every(q => q.submitted);

          return !isEngagementLetterSigned || !allQuestionsSubmitted;
        });
    },
  },
  methods: {
    isEmpty,
    moment,
    getEngagementLetterSigned(section) {
      const isEngagementLetterSigned = Boolean(
        section.section_type === 2 && section.marked_completed,
      );

      return isEngagementLetterSigned;
    },

    itemsToReviewAndSubmit(section) {
      const allQuestionsToAnswered = this.filteredSectionQuestionsToBeAnswered(
        this.currentQuestionnaire,
        section,
      ).filter(
        question =>
          !question.submitted && !this.questionnairePartiallySubmitted,
      );

      const onlyNonFollowupQuestions = allQuestionsToAnswered.filter(
        question => !question.follow_up_question_id,
      );

      const numberedQuestions = allQuestionsToAnswered.map(question => {
        const questionIndex = onlyNonFollowupQuestions.findIndex(
          q => q.id === question.id,
        );
        const isFollowupQuestion = Boolean(
          question.follow_up_question_id && questionIndex !== -1,
        );
        const questionNumber = !isFollowupQuestion ? questionIndex + 1 : null;

        return {
          ...question,
          questionNumber,
        };
      });

      return numberedQuestions;
    },
  },
};
</script>

<style lang="css" scoped>
.engagement_letter_error_message {
  width: 100% !important;
}

.question-number {
  height: 32px;
  width: 32px;

  line-height: 32px;
}
</style>
